import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// 初始状态
const initialState = {
    userInfo: {},
    token: "",
    menus: [],
    rolesList: [],
    productData: {},
    productList: [],
    sidebarCollapse: false,
    goodsTypeTree:{},
    navList:[],
    navItem:{
    },
    permissions: [],
};

// 重置白名单：需要保留不重置的字段
const resetWhitelist = ["productData", "productList"];

const state = {
    ...initialState,
};

const actions = {
    // 官网二级导航
    setNavList({ commit }, navList) {
        commit("SET_NAV_LIST", navList);
    },
    setNavItem({ commit }, navItem) {
        commit("SET_NAV_ITEM", navItem);
    },
    // 设置用户信息
    setUserInfo({ commit }, userInfo) {
        commit("SET_USER_INFO", userInfo);
    },
    // 设置token
    setToken({ commit }, token) {
        commit("SET_TOKEN", token);
    },
    // 设置菜单列表
    setMenus({ commit }, menus) {
        commit("SET_MENUS", menus);
    },
    // 设置角色列表
    setRolesList({ commit }, rolesList) {
        commit("SET_ROLES_LIST", rolesList);
    },
    // 设置产品数据
    setProductData({ commit }, productData) {
        commit("SET_PRODUCTDATA", productData);
    },
    // 设置产品列表
    setProductList({ commit }, productList) {
        commit("SET_PRODUCTLIST", productList);
    },
    // 设置商品类别树
    setGoodsTypeTree({ commit }, goodsTypeTree) {
        commit("SET_GOODS_TYPE_TREE", goodsTypeTree);
    },
    setPermissions({ commit }, permissions) {
        commit("SET_PERMISSIONS", permissions);
    },
    // 切换侧边栏折叠状态（支持传参或自动切换）
    toggleSidebar({ commit, state }, collapse) {
        const newState = typeof collapse === "boolean" ? collapse : !state.sidebarCollapse;
        commit("SET_SIDEBAR_COLLAPSE", newState);
    },

    // 重置侧边栏状态
    resetSidebar({ commit }) {
        commit("SET_SIDEBAR_COLLAPSE", initialState.sidebarCollapse);
    },
    // 重置所有状态（退出登录时用）- 新增白名单逻辑
    resetAllState({ commit }) {
        Object.keys(initialState).forEach((key) => {
            // 跳过白名单中的字段，不执行重置
            if (resetWhitelist.includes(key)) return;

            const mutationName = `SET_${key.replace(/([A-Z])/g, "_$1").toUpperCase()}`;
            commit(mutationName, initialState[key]);
        });
    },
};

const mutations = {
    SET_NAV_ITEM(state, navItem) {
        state.navItem = navItem;
    },
    SET_NAV_LIST(state, navList) {
        state.navList = navList;
    },
    SET_USER_INFO(state, userInfo) {
        state.userInfo = userInfo;
    },
    SET_TOKEN(state, token) {
        state.token = token;
    },
    SET_MENUS(state, menus) {
        state.menus = menus;
    },
    SET_ROLES_LIST(state, rolesList) {
        state.rolesList = rolesList;
    },
    SET_PRODUCTDATA(state, productData) {
        state.productData = productData;
    },
    SET_PRODUCTLIST(state, productList) {
        state.productList = productList;
    },
    SET_SIDEBAR_COLLAPSE(state, collapse) {
        state.sidebarCollapse = collapse;
    },
    // 适配resetAllState的批量重置
    SET_SIDEBARCOLLAPSE(state, value) {
        state.sidebarCollapse = value;
    },
    SET_GOODS_TYPE_TREE(state, goodsTypeTree) {
        state.goodsTypeTree = goodsTypeTree;
    },
    SET_PERMISSIONS(state, permissions) {
        state.permissions = permissions;
    },
};

const getters = {
    userInfo: (state) => state.userInfo,
    token: (state) => state.token,
    menus: (state) => state.menus,
    rolesList: (state) => state.rolesList,
    productData: (state) => state.productData,
    productList: (state) => state.productList,
    sidebarCollapse: (state) => state.sidebarCollapse,
    goodsTypeTree: (state) => state.goodsTypeTree,
    navList: (state) => state.navList,
    navItem: (state) => state.navItem,
    permissions: (state) => state.permissions,
};

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    plugins: [createPersistedState({
        // 可选：指定只持久化部分状态，避免冗余
        paths: ["token", "userInfo", "menus", "rolesList", "sidebarCollapse","goodsTypeTree","navList","navItem","permissions"]
    })],
});